var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 931,
    viewBox: "0 0 361 931",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 930,
    transform: "translate(1 1)",
    fill: "white",
    fillOpacity: 0.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 0.5,
    x2: 360.25,
    y2: 0.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 30.5,
    x2: 360.25,
    y2: 30.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 60.5,
    x2: 360.25,
    y2: 60.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 90.5,
    x2: 360.25,
    y2: 90.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 120.5,
    x2: 360.25,
    y2: 120.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 150.5,
    x2: 360.25,
    y2: 150.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 180.5,
    x2: 360.25,
    y2: 180.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 210.5,
    x2: 360.25,
    y2: 210.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 240.5,
    x2: 360.25,
    y2: 240.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 270.5,
    x2: 360.25,
    y2: 270.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 300.5,
    x2: 360.25,
    y2: 300.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 330.5,
    x2: 360.25,
    y2: 330.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 360.5,
    x2: 360.25,
    y2: 360.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 390.5,
    x2: 360.25,
    y2: 390.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 420.5,
    x2: 360.25,
    y2: 420.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 450.5,
    x2: 360.25,
    y2: 450.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 480.5,
    x2: 360.25,
    y2: 480.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 510.5,
    x2: 360.25,
    y2: 510.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 540.5,
    x2: 360.25,
    y2: 540.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 570.5,
    x2: 360.25,
    y2: 570.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 600.5,
    x2: 360.25,
    y2: 600.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 630.5,
    x2: 360.25,
    y2: 630.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 660.5,
    x2: 360.25,
    y2: 660.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 690.5,
    x2: 360.25,
    y2: 690.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 720.5,
    x2: 360.25,
    y2: 720.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 750.5,
    x2: 360.25,
    y2: 750.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 780.5,
    x2: 360.25,
    y2: 780.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 810.5,
    x2: 360.25,
    y2: 810.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 840.5,
    x2: 360.25,
    y2: 840.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 870.5,
    x2: 360.25,
    y2: 870.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 900.5,
    x2: 360.25,
    y2: 900.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 930.5,
    x2: 360.25,
    y2: 930.5,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 931,
    x2: 0.499974,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 30.5,
    y1: 931,
    x2: 30.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 60.5,
    y1: 931,
    x2: 60.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 90.5,
    y1: 931,
    x2: 90.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 120.5,
    y1: 931,
    x2: 120.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 150.5,
    y1: 931,
    x2: 150.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 180.5,
    y1: 931,
    x2: 180.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 210.5,
    y1: 931,
    x2: 210.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 240.5,
    y1: 931,
    x2: 240.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 270.5,
    y1: 931,
    x2: 270.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 300.5,
    y1: 931,
    x2: 300.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 330.5,
    y1: 931,
    x2: 330.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 360.5,
    y1: 931,
    x2: 360.5,
    y2: 1,
    stroke: "#282828",
    strokeOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridBlack);
export default __webpack_public_path__ + "static/media/grid_black.7bb50936fae2406e89417eb8b7f52e90.svg";
export { ForwardRef as ReactComponent };